import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoomContext } from '../../../../../RoomContext';
import { withStyles } from '@material-ui/core/styles';
import { useIntl, FormattedTime, FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import classnames from 'classnames';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';
import Alert from '@material-ui/lab/Alert';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import './styles.css';
import Preview from '../../../../popups/docShare/myFiles/components/preview';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

const styles = (theme) =>
	({
		root :
	{
		display    : 'flex',
		flexShrink : 0,
		// backgroundColor : '#a9daeb',
		boxShadow  : 'none',
		padding    : '0.5rem 0',
		wordWrap   : 'break-word',
		wordBreak  : 'break-all',
		alignItems : 'center',
		position   : 'relative'

	},
		single :
	{
		marginTop    : theme.spacing(1),
		borderRadius : '10px 10px 10px 10px'
	},
		combinedBegin :
	{
		marginTop    : theme.spacing(1),
		borderRadius : '10px 10px 0px 0px'
	},

		combinedMiddle :
	{
		marginBottom : theme.spacing(0),
		borderRadius : '0px 0px 0px 0px'
	},
		combinedEnd :
	{
		marginBottom : theme.spacing(0),
		borderRadius : '0px 0px 10px 10px'
	},
		combinedTime :
	{
		width          : '75px',
		alignSelf      : 'center',
		fontSize       : '13px',
		color          : '#000000ab',
		display        : 'flex',
		justifyContent : 'center'

	},
		sent :
	{
		maxWidth      : '100%',
		flexDirection : 'row-reverse'
	},
		received :
	{
		alignItems : 'flex-end',
		width      : '100%'
	},
		name : {

		},
		avatar : {
			display        : 'flex',
			justifyContent : 'center',
			padding        : '12px 6px 20px 0px',
			'& img'        : {
				borderRadius    : '50%',
				width           : '2rem',
				height          : '2rem',
				alignSelf       : 'center',
				objectFit       : 'cover',
				backgroundColor : '#e0e0e085'
			}
		},
		meContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		alignItems    : 'flex-end',
		marginTop     : '8px',
		position      : 'relative',
		paddingRight  : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		meContentFile :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '100%',
		alignItems    : 'flex-end',
		marginTop     : '8px',
		paddingRight  : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		peerContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		marginTop     : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		'@keyframes fadeIn' : {
			'from' : {
				backgroundColor : '#24a4c4'
			},
			'to' : {
				backgroundColor : '#e0e0e085'
			}
		},
		isseen : {
			animation         : '$fadeIn 2s linear',
			animationFillMode : 'forwards'
		},
		text :
	{
		display       : 'flex',
		flex          : '1',
		flexDirection : 'column',
		padding       : '0px 4px',
		overflow      : 'hidden'
		// padding       : '8px'
	},
		fileInfo :
	{
		display    : 'flex',
		alignItems : 'center',
		padding    : '0',
		cursor     : 'pointer'
	},
		displayFile :
	{
		width        : '100%',
		height       : 'auto',
		overflow     : 'hidden',
		aspectRatio  : '18/9',
		borderRadius : '4px',
		position     : 'relative'
	},
		imgFile :
	{
		width        : '100%',
		height       : 'auto',
		objectFit    : 'cover',
		borderRadius : '8px',
		cursor       : 'pointer'
	},
		imgFile1 :
	{
		width        : '100%',
		height       : '100%',
		objectFit    : 'contain',
		borderRadius : '8px',
		cursor       : 'pointer'
	},
		// 	videoFile :
		// {
		// 	width        : '100%',
		// 	height       : '100%',
		// 	borderRadius : '8px',
		// 	cursor       : 'pointer'
		// },
		previewWindow :
	{
		position        : 'fixed',
		height          : '100vh',
		width           : '100vw',
		display         : 'flex',
		flex            : 'none',
		flexDirection   : 'column',
		gap             : '16px',
		zIndex          : '2000',
		left            : '0',
		top             : '0',
		backgroundColor : '#043040'
	},
		cImg :
	{
		width  : '16px',
		height : '16px',
		cursor : 'pointer'
	},
		previewSub :
	{
		width        : '100%',
		height       : '100%',
		// aspectRatio  : '16/9',
		borderRadius : '8px',
		overflow     : 'hidden',
		textAlign    : 'center'

	}
	});

const File = (props) =>
{

	const intl = useIntl();
	// const audioRef = useRef(null); // Define the audioRef
	// const [ currentlyPlayingAudio, setCurrentlyPlayingAudio ] = useState(null);

	const {
		roomClient,
		name,
		canShareFiles,
		url,
		time,
		file,
		classes,
		sender,
		isseen,
		format,
		avatar,
		chatBackgroundColor,
		fileName,
		fileType,
		index,
		setIsPlaying,
		isPlaying,
		isPrivateMessage,
		preview, setPreview, setFileUrl, fileUrl
	} = props;

	const audioRef = useRef(null);
	// const [ isPlaying, setIsPlaying ] = useState(false);
	const [ currentTime, setCurrentTime ] = useState(0);
	const [ duration, setDuration ] = useState(0);

	// const handlePauseOtherAudios = () =>
	// {
	// 	const audioElements = document.querySelectorAll('audio');

	// 	audioElements.forEach((audio) =>
	// 	{
	// 		if (audio !== audioRef.current)
	// 		{
	// 			audio.pause();
	// 		}
	// 	});
	// 	setIsPlaying((prevState) => ({
	// 		...prevState,
	// 		[index] : false
	// 	}));
	// };

	const handlePauseOtherAudios = () =>
	{
		const audioElements = document.querySelectorAll('#privateChat');

		audioElements.forEach((audio) =>
		{
			if (audio !== audioRef.current)
			{
				audio.pause();
			}
			setIsPlaying(null);
		});
	};

	const handlePlay = () =>
	{
		const audioElement = audioRef.current;

		handlePauseOtherAudios();

		if (isPlaying===index)
		{
			audioElement.pause();
			setIsPlaying(null);
		}
		else
		{
			audioElement.play();
			setIsPlaying(index);
		}

	};

	const handlePreview = () =>
	{
		if ([ 'pdf', 'png', 'jpg', 'ppt', 'doc', 'mp4', 'image', 'video', 'xlsx', 'pptx', 'xls' ].includes(fileType))
		{
			handlePauseOtherAudios();
			setFileUrl({
				fileName : fileName,
				fileType : fileType,
				fileURL  : url
			});
			setPreview(true);
		}
	};

	const handleClosePreview =() =>
	{
		setPreview(false);
		setFileUrl({});
	};

	const handleDownload = () =>
	{
		fetch(file?.url)
			.then((response) =>
			{
				if (!response.ok)
				{
					throw new Error('Network response was not ok');
				}

				return response.blob();
			})
			.then((blob) =>
			{
				const Url = window.URL.createObjectURL(blob);

				const a = document.createElement('a');

				a.style.display = 'none';
				a.href = Url;
				a.download = file?.fileName;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(Url);
				document.body.removeChild(a);
			})
			.catch((error) =>
			{
				console.error(intl.formatMessage({ id: 'Error_downloading_file', defaultMessage: 'Error downloading file' }), error);
			});
	};

	useEffect(() =>
	{
		const audioElement = audioRef.current;

		if (!audioElement) return;

		const handleTimeUpdate = () =>
		{
			setCurrentTime(audioElement.currentTime);
		};

		const handleLoadedMetadata = () =>
		{
			setDuration(audioElement.duration);
		};
		const handleAudioEnd = () =>
		{
			setIsPlaying(null);
			setCurrentTime(0);
		};

		audioElement.addEventListener('timeupdate', handleTimeUpdate);
		audioElement.addEventListener('loadedmetadata', handleLoadedMetadata);
		audioElement.addEventListener('ended', handleAudioEnd);

		return () =>
		{
			audioElement.removeEventListener('timeupdate', handleTimeUpdate);
			audioElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
			audioElement.removeEventListener('ended', handleAudioEnd);
		};
	}, []);

	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	const formatTime = (timeInSeconds) =>
	{
		const minutes = Math.floor(timeInSeconds / 60);
		const seconds = Math.floor(timeInSeconds % 60);

		return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
	};

	console.log('prrrrr', preview, setPreview);

	const calculateProgress = () =>
	{
		if (!audioRef.current || !duration) return 0;

		return (currentTime / duration) * 100;
	};

	return (
		<div
			className={classnames(
				classes.root,
				sender === 'client' ? classes.sent : classes.received,
				// isseen && sender === 'response' ? classes.isseen : null,
				classes[format]
			)}
			data-name={name}
			data-isseen={isseen}
			data-time={time}
		>
			{sender !== 'client' &&
				<div className={classes.avatar}>
					{/* <img src={avatar} alt='Avatar' /> */}
					<img onError={(e) => { e.target.onerror = null; handleImageError(); }} src={avatar && avatar !== '' && !imageError ? `https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${avatar}` : 'images/avatar.svg'} alt='Avatar' />
				</div>
			}
			<div className={(sender === 'client' && fileType === 'image') ? classes.meContent : sender === 'client' ? classes.meContentFile : sender !== 'client' ? classes.peerContent : ''}>
				<div className={sender === 'client' ? 'meMsg' : 'peerMsg'} style={sender === 'client' ? { backgroundColor: '#a9daeb', borderColor: '#a9daeb', display: 'flex', flexDirection: 'column' } : { backgroundColor: '#eaecf2', borderColor: '#eaecf2', display: 'flex', flexDirection: 'column' }}>
					{sender === 'client' ? '' : (!isPrivateMessage && <small>{name}</small>)}
					{(fileType === 'image' || fileType === 'video' || fileType === 'audio')
						?
						(fileType === 'audio' ?
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<audio id='privateChat' ref={audioRef} src={url}/>
								<IconButton onClick={handlePlay} aria-label={isPlaying===index ? 'Pause' : 'Play'}>
									{isPlaying===index ? <PauseIcon /> : <PlayArrowIcon />}
								</IconButton>
								<Typography variant='body1' style={{ margin: '0 10px' }}>
									{formatTime(currentTime)} / {formatTime(duration)}
								</Typography>

								<LinearProgress variant='determinate' value={calculateProgress()} style={{ flexGrow: 1, height: '10px' }} />

								<IconButton onClick={handleDownload} aria-label='Download'>
									<GetAppIcon />
								</IconButton>
							</div>
							:<div className={classes.displayFile} onClick={handlePreview}>
								{fileType === 'image'?<img className={classes.imgFile} src={url} alt='imgs' />:<video className={classes.videoFile}>
									<source src={url} type='video/mp4'/>
									Your browser does not support the video tag.
								</video>}
								{
									fileType === 'video' &&
									<div className='flexCol aCntr jCntr videoPlay pointer'>
										<div className='flexAutoCol aCntr jCntr pRel'>
											<PlayArrowRoundedIcon style={{ color: 'black' }} fontSize='large' />
										</div>
									</div>
								}
							</div>)
						: <>
							<div
								className='flexRow aCntr pointer'
								onClick={handlePreview}
							>
								<div className='flexAutoRow'>
									{/* {fileType === 'pdf' ? <img alt='' src='/icons/pdf.svg' /> :
										fileType === 'xlsx' ? <img alt='' src={`/documents/${fileType}.png`} /> :
											fileType === 'ppt' ? <img alt='' src='/icons/ppt.svg' /> :
												fileType === 'pptx' ? <img alt='' src='/icons/pptx.svg' /> */}
									{(fileType === 'pdf' || fileType === 'xlsx' || fileType === 'ppt' || fileType === 'pptx' || fileType === 'xls') ? <img className='customFileDisplay' alt='' src={`/documents/${fileType}.png`} />
										: <DescriptionIcon />}
								</div>
								<div className='flexAutoCol pdngHXS msgWdth'>
									<span className='ellipse'>{fileName}</span>
									<div className='flexRow aCntr'>
										<small className='pdngRXS'>{(file?.size / (1024 * 1024)).toFixed(2) > 1 ? `${(file?.size / (1024 * 1024)).toFixed(2)} MB` : `${(file?.size / 1024).toFixed(2)} KB`}</small>
										{/* {sender !== 'client' && */}
										<div onClick={
											!canShareFiles ?
												undefined :
												() => handleDownload()
										}
										>
											<Tooltip
												title={intl.formatMessage({
													id             : 'filesharing.download',
													defaultMessage : 'Download'
												})}
												placement='top'
												enterDelay='700'
												enterNextDelay='700'

											>
												<IconButton
													size='small'
													variant='contained'
													component='span'
													className={classes.button}
													disabled={!canShareFiles ? true : false}
													aria-label={intl.formatMessage({
														id             : 'filesharing.download',
														defaultMessage : 'Download'
													})}
												>
													<GetAppIcon fontSize='small' />
												</IconButton>
											</Tooltip>
										</div>

									</div>
								</div>
							</div>
							{/* <div>

							{file.active &&
								<progress value={file.progress} />
							}
						</div> */}
							{!canShareFiles &&
								<div>
									<Alert severity='error'>
										<FormattedMessage
											id='label.fileSharingUnsupported'
											defaultMessage='File sharing not supported'
										/>
									</Alert>
								</div>
							}
						</>
					}
					{
						(fileType === 'image' || fileType === 'video') &&

						<div className={`flexInline aCntr jCntr  pointer ${sender === 'client' ? 'downloadIconwidthClientSide' : 'downloadIconwidth'}`}
							onClick={
								!canShareFiles ?
									undefined :
									() => handleDownload()
							}
						>
							<Tooltip
								title={intl.formatMessage({
									id             : 'filesharing.download',
									defaultMessage : 'Download'
								})}
								placement='top'
							>
								<div className='flexRow aCntr jCntr pRel pdngHSM'>
									{sender !== 'client' && <div className='downLoadWhiteIcon'>
										<img src='/icons/imageDownload.svg' alt='download' />
									</div>}
									<small className='wTxt pdngLSM'>{(file?.size / (1024 * 1024)).toFixed(2) > 1 ? `${(file?.size / (1024 * 1024)).toFixed(2)} MB` : `${(file?.size / 1024).toFixed(2)} KB`}</small>
								</div>
							</Tooltip>
						</div>
					}
				</div>
				<small className='small'>
					<FormattedTime value={new Date(time)} />
				</small>
			</div>
			{preview && <Preview handleClosePreview={handleClosePreview} classes={classes} fname={fileUrl?.fileName} ftype={fileUrl?.fileType} furl={fileUrl?.fileURL} />}
		</div>
	);
};

File.propTypes = {
	roomClient          : PropTypes.object.isRequired,
	url                 : PropTypes.string.isRequired,
	time                : PropTypes.any,
	name                : PropTypes.string.isRequired,
	picture             : PropTypes.string,
	canShareFiles       : PropTypes.bool.isRequired,
	file                : PropTypes.object.isRequired,
	classes             : PropTypes.object.isRequired,
	isseen              : PropTypes.bool,
	sender              : PropTypes.string.isRequired,
	width               : PropTypes.number.isRequired,
	format              : PropTypes.string,
	avatar              : PropTypes.string,
	chatBackgroundColor : PropTypes.string,
	fileName            : PropTypes.string,
	fileType            : PropTypes.string,
	items               : PropTypes.any,
	index               : PropTypes.any,
	setIsPlaying        : PropTypes.any,
	isPlaying           : PropTypes.any,
	isPrivateMessage    : PropTypes.any,
	preview             : PropTypes.any,
	setPreview          : PropTypes.any,
	fileUrl             : PropTypes.any,
	setFileUrl          : PropTypes.any
};

const mapStateToProps = (state, { time }) =>
{
	return {
		// file          : state.files.files.filter((item) => item.time === time)[0],
		canShareFiles : state.me.canShareFiles
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.files === next.files &&
				prev.me.canShareFiles === next.me.canShareFiles
			);
		}
	}
)(withStyles(styles)(File)));